import { IDropDownItem } from 'core/interface/dropDown';

const industries: IDropDownItem[] = [
  {
    value: 'some',
    to_show: 'some industry'
  }
];

const jobContracts: IDropDownItem[] = [
  { value: 1, to_show: 'Permanent' },
  { value: 2, to_show: 'Freelance' },
  { value: 3, to_show: 'Internship' }
];

export { industries, jobContracts };
